.field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	min-width: 0;
}
.col12 {
	grid-column: span 12;
}
.col6 {
	grid-column: span 6;
}
.col3 {
	grid-column: span 3;
}

.label {
	font-weight: 600;
	font-size: 0.875rem;
	color: #374151;
	margin-bottom: 0;
}
.req {
	color: #ef4444;
	margin-left: 2px;
}

.helper {
	font-size: 0.8rem;
	color: #6b7280;
}
.error {
	font-size: 0.8rem;
	color: #b91c1c;
	margin-top: -5px;
}

.desc {
	display: grid;
	gap: 0.25rem;
}

.descItem {
	display: flex;
	align-items: flex-start;
	gap: 0.35rem;
	color: #374151;
	font-size: 0.85rem;
}
.descIcon {
	width: 16px;
	height: 16px;
	color: #6b7280;
	margin-top: 2px;
}

@media (max-width: 640px) {
	.col6 {
		grid-column: span 12;
	}
}
